import React from "react";

// import i1 from '../Assets/grid/seocialmarketing1_11zon.jpg';
// import i2 from '../Assets/grid/DigitalAdvertising_11zon.jpg';
// import i3 from '../Assets/grid/Digitalmarketing_11zon.jpg';
// import i4 from '../Assets/grid/seo1_11zon.jpg';
// import i5 from '../Assets/Services/webdevelopment.jpg';

import i1 from '../Assets/new/Website Management.png';
import i2 from '../Assets/new/Performance Marketing 2.jpg';
import i3 from '../Assets/new/Graphic Design.png';
import i4 from '../Assets/new/Digital Marketing.png';
import i5 from '../Assets/new/Email Marketing.png';

const GridDesign = () => {
  return (
    <section className="w-full">

      {/* Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">

        {/* LEFT BIG IMAGE */}
        <div className="relative group col-span-1 md:col-span-2 lg:col-span-1 h-[300px] md:h-[500px] lg:h-full">
          <img
            src={i1}
            alt="social"
            className="w-full h-full object-cover"
          />

          {/* Hover Content */}
          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
            <h2 className="text-white text-2xl font-bold">
              Website Management
            </h2>
          </div>
        </div>

        {/* RIGHT GRID */}
        <div className="col-span-1 md:col-span-2 grid grid-cols-2">

          {/* ITEM 1 */}
          <div className="relative group h-[200px] md:h-[250px]">
            <img
              src={i2}
              className="w-full h-full object-cover"
              alt=""
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
              <h2 className="text-white font-bold text-lg text-center px-2">
                Performance Marketing
              </h2>
            </div>
          </div>

          {/* ITEM 2 */}
          <div className="relative group h-[200px] md:h-[250px] ">
            <img
              src={i3}
              className="w-full h-full object-cover"
              alt=""
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
              <h2 className="text-white font-bold text-lg">
                Graphic Design
              </h2>
            </div>
          </div>

          {/* ITEM 3 */}
          <div className="relative group h-[200px] md:h-[250px]">
            <img
              src={i4}
              className="w-full h-full object-cover"
              alt=""
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
              <h2 className="text-white font-bold text-lg text-center px-2">
                Digital Marketing
              </h2>
            </div>
          </div>

          {/* ITEM 4 */}
          <div className="relative group h-[200px] md:h-[250px]">
            <img
              src={i5}
              className="w-full h-full object-cover"
              alt=""
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
              <h2 className="text-white font-bold text-lg text-center px-2">
                Email Marketing
              </h2>
            </div>
          </div>

        </div>
      </div>

    </section>
  );
};

export default GridDesign;